(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('BreakdownService', BreakdownService);

  BreakdownService.$inject = ['$resource'];

	 function BreakdownService ($resource) {
    return $resource(apiUrl + '/breakdowns/:id', { id: '@id' }, {
      all: { method: 'GET', params: {}, isArray: true },
      activate: { url: apiUrl + '/breakdowns/activate/:id', method: 'POST', params: {}, isArray: true, timeout: 5000 }
    });
  }
})();
